// extracted by mini-css-extract-plugin
export var fullGrid = "_3r-3";
export var pdpPreviewContainer = "_3r-1";
export var previewContainer = "_3r-0";
export var togglePreviewContainer = "_3r-2";